import httpClient from "../../clients/httpClient";

export const getResourceLinks = () =>
    httpClient.get("/api/v1/admin/resource-links");

export const createResourceLink = (payload: { title: string; url: string; icon?: string }) =>
    httpClient.post("/api/v1/admin/resource-links", payload);

export const updateResourceLink = (id: number, payload: { title: string; url: string; icon?: string }) =>
    httpClient.patch(`/api/v1/admin/resource-links/${id}`, payload);

export const deleteResourceLink = (id: number) =>
    httpClient.delete(`/api/v1/admin/resource-links/${id}`);

export const reorderResourceLinks = (ids: number[]) =>
    httpClient.patch("/api/v1/admin/resource-links/reorder", { ids });

export const getTenantResourceLinks = () =>
    httpClient.get("/api/v1/resource-links");
